// ################# CODE VERSION 2 ################# //

import React from "react";
import "./HomePage.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/useAuth";

import comfort from "../../assets/images/comfort.png";
import process from "../../assets/images/process.png";
import dpPowerWorld from "../../assets/images/DP_Power_world.png";

export default function HomePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const cards = [
    { id: 1, title: "COMFORT", img: comfort, onClick: () => navigate("/dashboard") },
    { id: 2, title: "PROCESS", img: process, onClick: () => {} },
    // { id: 3, title: "CARD 3", img: ""},
    // { id: 4, title: "CARD 4", img: ""},
    // { id: 5, title: "CARD 5", img: ""},
  ];

  const handleKey = (e, onClick) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  const handleMouseMove = (e) => {
    const el = e.currentTarget;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const px = (x / rect.width - 0.5) * 18; // rotateY
    const py = (y / rect.height - 0.5) * -10; // rotateX
    el.style.transform = `perspective(900px) rotateY(${px}deg) rotateX(${py}deg) scale(1.05)`;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "";
  };

  return (
    <div className="hp-container">
      <div className="hp-content">
        <div className="hp-auth-links">
          {user ? (
            <>
              <span className="hp-user-email">{user.email}</span>
              <button type="button" className="hp-auth-btn" onClick={() => logout()}>
                Logout
              </button>
            </>
          ) : (
            <button type="button" className="hp-auth-btn" onClick={() => navigate("/login")}>
              Login
            </button>
          )}
        </div>
        <div className="hp-logo-wrap">
          <img src={dpPowerWorld} alt="DP Power World" className="hp-logo-img" />
        </div>
        <h2 className="hp-heading">CHILLER SELECTION SOFTWARE</h2>
        <p className="hp-sub">Choose a product to begin.</p>

        <div className={`hp-carousel ${cards.length <= 3 ? "center-cards" : ""}`}>
          {cards.map((card) => (
            <div
              key={card.id}
              role="button"
              tabIndex={0}
              aria-label={card.title}
              className="hp-card"
              onClick={card.onClick}
              onKeyDown={(e) => handleKey(e, card.onClick)}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
              // style={{ backgroundImage: `url(${card.img})` }}
            >
              <div className="hp-card-overlay">
                <div className="hp-card-title">{card.title}</div>
                <div className="hp-card-cta">Explore →</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


// ################# CODE VERSION 1 ################# //

// import React from "react";
// import "./HomePage.css";
// import { useNavigate } from "react-router-dom";
// import comfort from "../../assets/images/comfort.png";
// import process from "../../assets/images/process.png";

// export default function HomePage() {
//   const navigate = useNavigate();

//   return (
//     <div className="hp-container">
//       {/* Main Content */}
//       <div className="hp-content">
//         <div className="hp-left-block">
//           {/* TECHNICAL SELECTION */}
//           <h2 className="hp-heading">TECHNICAL SELECTION</h2>

//           <div className="hp-options-wrapper">
//             {/* COMFORT */}
//             <div
//               className="hp-option-box comfort"
//               onClick={() => navigate("/dashboard")}
//               style={{ cursor: "pointer" }}
//             >
//               <img src={comfort} alt="" className="hp-option-img" />
//               <span className="hp-option-text">COMFORT</span>
//             </div>

//             {/* PROCESS */}
//             <div className="hp-option-box process">
//               <img src={process} alt="" className="hp-option-img" />
//               <span className="hp-option-text">PROCESS</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
